var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Thank You"}}),_c('ContentRow',[_c('ContentContainer',{staticClass:"content-container"},[_c('div',{staticClass:"thank-you"},[_c('p',[_vm._v("Thank you for your enquiry.")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }